// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1V4bW","title":"ClientInsurance_title__3y0tt","itemText":"ClientInsurance_itemText__1Ajli"};